module.exports = __webpack_public_path__ + "static/media/3DPPA2.3b17ac97.jpg";